module.exports = fox => {
	require('template-modifiers')(fox);
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/dependencies/modifiers.es.js